const LISTAR_DADOS = (state, payload) => {
  state.items = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_FORMULARIO_SELECIONADO = (state, payload) => {
  state.selecionado = payload
}

export {
    LISTAR_DADOS,
    CARREGANDO,
    INSERIR_FORMULARIO_SELECIONADO
}